import { Api } from "../axios-config";

export interface IPdf {
  _id: string;
  name: string;
  size: number;
  key: string;
  url: string;
  date: string;
}

const downloadPdf = async (id: string): Promise<void> => {
  try {
    const urlRelativa = `/pdfs/download/${id}`;
    const response = await Api.get(urlRelativa, {
      responseType: 'blob'
    });
    
    // Cria uma URL temporária para o blob
    const blob = new Blob([response.data], { type: 'application/pdf' });
    const url = window.URL.createObjectURL(blob);
    
    // Cria um link temporário e clica nele para iniciar o download
    const link = document.createElement('a');
    link.href = url;
    link.download = 'certificado.pdf';
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    
    // Libera a URL após um tempo
    setTimeout(() => {
      window.URL.revokeObjectURL(url);
    }, 100);
  } catch (error) {
    throw new Error((error as { message: string }).message || "Erro ao baixar PDF");
  }
};

const viewPdf = async (id: string): Promise<void> => {
  try {
    const urlRelativa = `/pdfs/download/${id}`;
    const response = await Api.get(urlRelativa, {
      responseType: 'blob'
    });
    
    // Cria uma URL temporária para o blob
    const blob = new Blob([response.data], { type: 'application/pdf' });
    const url = window.URL.createObjectURL(blob);
    
    // Abre em nova aba
    window.open(url, '_blank');
    
    // Libera a URL após um tempo
    setTimeout(() => {
      window.URL.revokeObjectURL(url);
    }, 100);
  } catch (error) {
    throw new Error((error as { message: string }).message || "Erro ao visualizar PDF");
  }
};

export const pdfsServices = {
  downloadPdf,
  viewPdf
};
